<button nz-button nzType="text" (click)="onCancelClick()">Cancel</button>

<app-save-button (click)="onSaveClick()"></app-save-button>
